<script lang="ts" setup>
import { useData } from 'vitepress'
import { useCommentConfig } from '../../composables/useCommentConfig'
import Waline from './VWaline.vue'
import { computed } from 'vue'

const { type, options } = useCommentConfig()
const { frontmatter } = useData()
const showComment = computed(() => {
  return options.value.hideComments !== true || frontmatter.value.hideComments === false
})
</script>
<template>
  <section class="v-comment">
    <Waline v-if="type === 'waline' && showComment" :options="options" />
  </section>
</template>